import { Pipe, PipeTransform } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { TimeService } from '@services/common/time.service';
import memo from 'memo-decorator';

@Pipe({
  name: 'projectDetailDateFormat'
})
export class ProjectDetailDateFormatPipe implements PipeTransform {
  constructor(
    private _timeService: TimeService,
    private _translate: TranslateService
  ) {}

  @memo({
    resolver: (...args: any[]) => {
      return { ...args };
    },
    cache: new WeakMap()
  })
  transform(value: string, format = '', lang: string): string {
    if (!value) {
      return '';
    }
    const resultString = this._timeService.getDateFormat(value, format);
    const resultNumber = this._timeService.getDateFormat(value, '');

    const [day, month] = resultString.split(' ');
    const [dayNumber, monthNumber, year] = resultNumber.split('.');

    return `${this._translate.instant(day)} ${dayNumber} ${this._translate.instant(month)}, ${year}`;
  }
}
